/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";

/**
 *
 * @export
 * @interface StudentCVAccessDTO
 */
export interface StudentCVAccessDTO {
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	studentId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly name?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly facultyNameEn?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly facultyNameRo?: string | null;
	/**
	 *
	 * @type {StudentYearEnum}
	 * @memberof StudentCVAccessDTO
	 */
	year?: StudentYearEnum;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly linkedinUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccessDTO
	 */
	readonly cvFileName?: string | null;
}

export function StudentCVAccessDTOFromJSON(json: any): StudentCVAccessDTO {
	return StudentCVAccessDTOFromJSONTyped(json, false);
}

export function StudentCVAccessDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): StudentCVAccessDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		studentId: !exists(json, "studentId") ? undefined : json["studentId"],
		name: !exists(json, "name") ? undefined : json["name"],
		email: !exists(json, "email") ? undefined : json["email"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		facultyNameEn: !exists(json, "facultyNameEn")
			? undefined
			: json["facultyNameEn"],
		facultyNameRo: !exists(json, "facultyNameRo")
			? undefined
			: json["facultyNameRo"],
		year: !exists(json, "year")
			? undefined
			: StudentYearEnumFromJSON(json["year"]),
		linkedinUrl: !exists(json, "linkedinUrl") ? undefined : json["linkedinUrl"],
		cvFileName: !exists(json, "cvFileName") ? undefined : json["cvFileName"],
	};
}

export function StudentCVAccessDTOToJSON(
	value?: StudentCVAccessDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		studentId: value.studentId,
		year: StudentYearEnumToJSON(value.year),
	};
}
